import * as models from './models';
import * as collections from './collections';
import * as views from './views';
import * as parser from './parser';
import events from './events';

export {
    models,
    collections,
    views,
    events,
    parser
};



// WEBPACK FOOTER //
// ./plugins/slicer_cli_web/web_client/index.js